import "./send-history-report-modal.scss";

import classNames from "classnames";
import dayjs from "dayjs";
import React, { useRef, useState } from "react";

import { ReactComponent as MailYellow } from "@client/components/reusable/SvgIcons/library/mail-yellow.svg";
import { ReactComponent as PickupsCheck } from "@client/components/reusable/SvgIcons/library/pickups-check.svg";
import { useRootContext } from "@client/context/RootContext";

import { DropDown, DropDownOption } from "../reusable/drop-down";
import SvgIcon from "../reusable/SvgIcons";
import { SendHistoryReportProps } from "./send-history-report";

export const SendHistoryReportModal: React.FC<SendHistoryReportProps> = (
	props
) => {
	const { vendorStore, modalStore } = useRootContext();

	const initiallySelectedEmails = useRef(
		localStorage.getItem("selectedReportEmails")
			? (JSON.parse(
					localStorage.getItem("selectedReportEmails")!
			  ) as DropDownOption[])
			: []
	);
	const [selectedReportEmails, setSelectedReportEmails] = useState<
		DropDownOption[]
	>(initiallySelectedEmails.current);
	const [submitted, setSubmitted] = useState(false);

	const dropdownOptions = useRef(
		(vendorStore.vendorDetails?.report_emails || []).map((email, idx) => ({
			id: idx,
			label: email,
		}))
	);

	async function onSubmit() {
		if (submitted) {
			modalStore.removeModal("history-report-modal");
			return;
		}

		const created_past = (() => {
			switch (props.timeFrameValue) {
				case 1:
					return dayjs().subtract(3, "days").toISOString();
				case 2:
					return dayjs().subtract(7, "days").toISOString();
				case 3:
					return dayjs().subtract(1, "month").toISOString();
				case 4:
					return dayjs().subtract(3, "month").toISOString();

				default:
					return dayjs().subtract(1, "day").toISOString();
			}
		})();

		const params = {
			...props,
			created_past,
			vendor_id: vendorStore.vendorDetails.id,
			send_to: selectedReportEmails.map((email) => email.label).join(","),
		};

		vendorStore.orderOperations.sendOrdersMail(params);
		setSubmitted(true);
	}
	function setSelectedReportEmail_handler(
		id: number /*state: DropDownOption[]*/
	) {
		const state = dropdownOptions.current.filter((option) => option.id === id);
		localStorage.setItem("selectedReportEmails", JSON.stringify(state));

		setSelectedReportEmails(state);
	}

	return (
		<div className={"modal-report-wrapper"}>
			<div className="modal-report-inner">
				{submitted ? (
					<div className="modal-report-check">
						<PickupsCheck style={{ marginBottom: 10 }} />
						<div>Orders{"'"} report sent!</div>
					</div>
				) : (
					<>
						<div className="modal-report-icon">
							<SvgIcon width="32" component={MailYellow} />
						</div>
						<div>Export orders</div>
						<DropDown
							options={dropdownOptions.current}
							// defaultSelectedOptions={initiallySelectedEmails.current}
							defaultValue={initiallySelectedEmails.current?.[0]?.id || 0}
							label="Select email(s) to send export to"
							// setSelectedOptionsFromParent={setSelectedReportEmail_handler}
							setOptionValueFromParent={setSelectedReportEmail_handler}
							// useCheckbox
							dropDownWrrapperClassname="modal-report-dropdown-wrapper"
							dropDownClassname="modal-report-dropdown"
							dropDownOptionsClassname="modal-report-dropdown-options"
							autohide
						/>
					</>
				)}
			</div>
			<button
				disabled={selectedReportEmails.length === 0}
				className={classNames("modal-report-submit", {
					"modal-report-submit-disabled": !selectedReportEmails.length,
				})}
				onClick={onSubmit}
			>
				{submitted ? "Ok" : "Submit"}
			</button>
		</div>
	);
};
